import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
interface FAQAccordionProps {
  items: FAQItem[];
}
export function FAQAccordion({
  items
}: FAQAccordionProps) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  return <div className="space-y-4 my-8" data-id="element-95">
      <div className="flex items-center gap-2 mb-6" data-id="element-96">
        <HelpCircle className="w-6 h-6 text-purple-600" data-id="element-97" />
        <h3 className="text-2xl font-bold text-slate-900" data-id="element-98">
          Frequently Asked Questions
        </h3>
      </div>

      {items.map((item, index) => <div key={index} className="border border-slate-200 rounded-lg overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-99">
          <button onClick={() => setActiveIndex(activeIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left bg-white hover:bg-slate-50 transition-colors" data-id="element-100">
            <span className="font-bold text-slate-800 text-lg pr-4" data-id="element-101">
              {item.question}
            </span>
            <motion.div animate={{
          rotate: activeIndex === index ? 180 : 0
        }} transition={{
          duration: 0.2
        }} data-id="element-102">
              <ChevronDown className="w-5 h-5 text-slate-400" data-id="element-103" />
            </motion.div>
          </button>

          <AnimatePresence data-id="element-104">
            {activeIndex === index && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} data-id="element-105">
                <div className="p-5 pt-0 text-slate-600 border-t border-slate-100 bg-slate-50/50 leading-relaxed" data-id="element-106">
                  {item.answer}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
}